<style lang="scss" scoped>
.product-card {
    &.highlighted .pricing-rates {
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
        z-index: 2;
        border-color: #2f55d4;
    }
}

.product-price {
    font-weight: 700;
    font-size: 25px;
}

.btn-vignette {
    background-color: #e3001b;
    color: white;
    outline: none;
    box-shadow: none;

    &:hover {
        background-color: darken(#e3001b, 10%);
    }
}

.btn-route-toll {
    background-color: #008035;
    color: white;

    &:hover {
        background-color: darken(#008035, 10%);
    }
}
</style>

<script>
export default {
    props: [
        'name',
        'urlName',
        'urlNames',
        'description',
        'selectedProduct',
        'selectedProductType',
        'smallerView',
        'configValue',
        'preselectId',
        'noticePopup',
        'showPrice',
    ],

    data() {
        return {
            noticeModal: {
                show: false,
                close: false,
                closeable: false,
            },
        };
    },

    computed: {
        highlighted() {
            return this.id === this.selectedProduct && this.selectedProductType === this.type;
        },

        /**
         * Determine if the product has an notice popup.
         *
         * @returns {boolean}
         */
        hasNoticePopup() {
            return typeof this.noticePopup === 'object' && this.noticePopup !== null;
        },
    },

    methods: {
        /**
         * Handle the selection callback of product.
         *
         * @returns {void}
         */
        select() {
            // In the case we have an notice popup, then we have to show it.
            if (this.hasNoticePopup) {
                this.noticeModal.show = true;
                this.noticeModal.close = false;
                this.noticeModal.closeable = false;

                return;
            }

            this.$emit('product-card-selected', this);
        },

        /**
         * In the case that the continue were chosen at the modal, we have to hide
         * the modal and continue the product order process.
         *
         * @returns {void}
         */
        onModalConfirmed() {
            this.noticeModal.show = false;
            this.noticeModal.closeable = true;
            this.noticeModal.close = true;

            this.$emit('product-card-selected', this);
        },

        /**
         * Handle the case that the user does not agree the text in the modal.
         *
         * @returns {void}
         */
        onModalNotConfirmed() {
            this.noticeModal.show = false;
            this.noticeModal.closeable = true;
            this.noticeModal.close = true;
        },
    },
};
</script>
